import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductDeliveryStatus from './product-delivery-status';
import ProductDeliveryStatusDetail from './product-delivery-status-detail';
import ProductDeliveryStatusUpdate from './product-delivery-status-update';
import ProductDeliveryStatusDeleteDialog from './product-delivery-status-delete-dialog';

const ProductDeliveryStatusRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductDeliveryStatus />} />
    <Route path="new" element={<ProductDeliveryStatusUpdate />} />
    <Route path=":id">
      <Route index element={<ProductDeliveryStatusDetail />} />
      <Route path="edit" element={<ProductDeliveryStatusUpdate />} />
      <Route path="delete" element={<ProductDeliveryStatusDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductDeliveryStatusRoutes;
